import React from 'react';

import type { RetailerPromo } from '../../@types/Retailer';
import { asHtml } from '../../helpers/markdown';
import Content from '../../styled-components/components/Content';
import { Image } from '../../styled-components/components/Image';
import { Link } from '../../styled-components/components/Link';
import Modal from '../../styled-components/components/Modal';
import { StackMedium } from '../../styled-components/components/Stack';

interface PromoModalProps {
  promo: RetailerPromo;
  onClose: () => void;
}

const PromoModal = ({ promo, onClose }: PromoModalProps) => (
  <Modal heading={promo.title} onClose={onClose}>
    {promo.image && (
      <StackMedium>
        <Image $fullWidth src={`${promo.image}?w=570`} alt={promo.title} />
      </StackMedium>
    )}
    <StackMedium>
      <Content dangerouslySetInnerHTML={{ __html: asHtml(promo.description) }} />
    </StackMedium>
    {promo.link && (
      <StackMedium>
        <Link
          href={promo.link.url}
          title={promo.link.name}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          {promo.link.name}
        </Link>
      </StackMedium>
    )}
  </Modal>
);

export default PromoModal;
